import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/motion/Reveal";

export const Intro = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="bg-ivory py-24 text-ink sm:py-32" data-testid="home-intro">
      <div className="shell grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal as="p" className="eyebrow flex items-center gap-3 text-plum-2"><span className="h-px w-10 bg-plum-2" /> Introduction</Reveal>
          <Reveal as="h2" delay={0.05} className="mt-6 font-display text-[2.4rem] font-light leading-[1.02] tracking-[-0.025em] sm:text-6xl">
            Technology That Creates <em className="text-plum-2">Possibility.</em>
          </Reveal>
          <Reveal delay={0.15} className="mt-12 hidden lg:block">
            <div className="relative h-[300px] w-[78%] overflow-hidden rounded-[22px] [clip-path:polygon(0_0,100%_0,100%_78%,78%_100%,0_100%)]">
              <motion.img src="/images/intro-team.webp" alt="African professionals in a collaborative technology meeting" loading="lazy" style={{ y }} className="absolute inset-0 h-[120%] w-full -translate-y-[8%] object-cover" />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 lg:pt-16">
          <Reveal as="p" className="font-display text-2xl font-light leading-snug text-ink sm:text-[2rem] sm:leading-[1.3]">
            VION Technology Limited (VION Tech) is an emerging technology and innovation company focused on practical technology education, intelligent business solutions, digital transformation and global opportunities.
          </Reveal>
          <Reveal as="p" delay={0.08} className="mt-8 max-w-xl text-base leading-relaxed text-ink/75 md:text-lg">
            We bring technology, education and opportunity together to help people build relevant skills, businesses work smarter and institutions prepare for a rapidly changing world.
          </Reveal>
          <Reveal delay={0.1} className="mt-12 lg:hidden">
            <div className="relative h-[280px] overflow-hidden rounded-[22px] sm:h-[380px]">
              <img src="/images/intro-team.webp" alt="African professionals in a collaborative technology meeting" loading="lazy" className="h-full w-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.12} className="mt-14 grid grid-cols-3 border-t border-ink/15 pt-6">
            {["Learn.", "Innovate.", "Transform."].map((w, i) => (
              <p key={w} className={`font-display text-xl italic sm:text-3xl ${i === 1 ? "text-plum-2" : "text-ink"}`}>{w}</p>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
